import type React from 'react';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import StandardButton from 'components/buttons/StandardButton';
import { useStyles } from 'components/dialogs/avoidance/styles';

interface AvoidanceDialogActionsProps {
  groupName?: string;
  numberOfSelected: number;
  cancelAction: () => void;
  chooseAvoidance?: () => void;
  clearAvoidanceRules?: () => void;
  clearParticipants?: () => void;
  saveGroup?: () => void;
}

const AvoidanceDialogActions: React.FC<React.PropsWithChildren<AvoidanceDialogActionsProps>> = ({
  groupName,
  numberOfSelected,
  cancelAction,
  chooseAvoidance,
  clearAvoidanceRules,
  clearParticipants,
  saveGroup,
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const htmlClass =
    numberOfSelected > 0
      ? `${classes.actionsSelectedTypography} ${classes.actionsTypography}`
      : classes.actionsTypography;
  const buttonText = chooseAvoidance ? t('choose') : t('saveGroup');
  const saveButtonDisabled = (saveGroup && numberOfSelected === 0) || (saveGroup && !groupName?.trim());

  const handleDeselectAll = () => {
    if (clearAvoidanceRules) {
      clearAvoidanceRules();
    } else if (clearParticipants) {
      clearParticipants();
    }
  };
  const handleConfirm = () => {
    if (chooseAvoidance) {
      chooseAvoidance();
    } else if (saveGroup) {
      saveGroup();
    }
  };

  return (
    <Grid container direction="row" justifyContent="space-between">
      <Grid item>
        <Grid container direction="row" spacing={2}>
          <Grid item>
            <Typography className={htmlClass}>
              {numberOfSelected} {t('scted')}
            </Typography>
          </Grid>
          {numberOfSelected > 0 && (
            <Grid item>
              <Typography className={classes.deselectAllTypography} onClick={handleDeselectAll}>
                {t('dstAll')}
              </Typography>
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid item>
        <Grid container direction="row" justifyContent="flex-end" spacing={2}>
          <Grid item>
            <StandardButton onClick={cancelAction}>{t('ccl')}</StandardButton>
          </Grid>
          <Grid item>
            <StandardButton disabled={saveButtonDisabled} variant="primary" onClick={handleConfirm}>
              {buttonText}
            </StandardButton>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AvoidanceDialogActions;
